var map = {
	"./game-level0.png": "AiZ3",
	"./game-level1.png": "nT0v",
	"./game-level2.png": "hYX8",
	"./game-level3.png": "dpyT"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a920";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/game ^\.\/game\-level.*\.png$
// module id = a920
// module chunks = 1